/**
 * Strip WhatsApp suffixes (@c.us, @lid, @s.whatsapp.net, etc.)
 * and return a clean phone number string.
 */
export function formatPhone(phone) {
  if (!phone) return '';
  return phone.replace(/@\S+$/, '');
}
